import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'

import styles from '../ProtocolsController.module.sass'

const PresetProtocolRow = (props) => {
	const { i18n, showDialog, deletePresetProtocol } = useGlobal()
	const { data, ...attributes } = props
	const { preset } = data
	const { bodyPart, injury, acutePhase } = preset

	const notesOptions = [
		{
			value: 'update',
			text: i18n`Update`,
			action: () =>
				showDialog &&
				showDialog(
					'EditPresetProtocolDialog',
					i18n`Edit Preset Protocols`,
					{
						bodyPartValue: bodyPart?.id,
						injuryValue: injury?.id,
						acutePhaseValue: acutePhase,
					},
					false,
					undefined,
					'center',
					'edit_preset_protocol'
				).catch(() => null),
		},
		{
			value: 'delete',
			text: i18n`Delete`,
			action: () =>
				deletePresetProtocol &&
				deletePresetProtocol({
					bodyPart: bodyPart?.id,
					injury: injury?.id,
					acutePhase,
				}),
		},
	]

	return (
		<HStack
			{...attributes}
			className={styles['protocol-row']}
			paddings={['small', 'normal', '']}
			justify='space-between'
			gap='xsmall'
			align='center'
			columns={[9, 1]}
		>
			<HStack justify='space-between' gap='small' columns={[4, 4, 1]}>
				<SlidingText>
					<small>{bodyPart?.name}</small>
				</SlidingText>
				<SlidingText>
					<small>{injury?.name}</small>
				</SlidingText>
				<HStack justify='center'>
					<small>
						<Icon
							className={styles['status-icon']}
							width='18px'
							height='18px'
							name={acutePhase ? 'check' : 'cross-alt'}
						/>
					</small>
				</HStack>
			</HStack>
			<HStack justify='flex-end'>
				<ModalOptions
					options={notesOptions}
					title={i18n`Options`}
					onSelect={(item) => {
						item && item.action && item.action()
					}}
				>
					<ActionButton
						className={styles['action-button']}
						icon='options'
					/>
				</ModalOptions>
			</HStack>
		</HStack>
	)
}

export const PresetProtocolHeader = (props) => {
	const { i18n } = useGlobal()
	return (
		<HStack
			className={styles['protocol-row']}
			paddings={['small', 'normal', '']}
			justify='space-between'
			gap='xsmall'
			align='center'
			columns={[9, 1]}
		>
			<HStack justify='space-between' gap='small' columns={[4, 4, 1]}>
				<small>
					<strong>{i18n`Body Part`}</strong>
				</small>
				<small>
					<strong>{i18n`Injury Type`}</strong>
				</small>
				<HStack justify='center'>
					<small>
						<strong>{i18n`Acute Phase`}</strong>
					</small>
				</HStack>
			</HStack>
			<HStack justify='flex-end'>
				<small>
					<strong>{i18n`Actions`}</strong>
				</small>
			</HStack>
		</HStack>
	)
}

export default PresetProtocolRow
